import { useRouter } from "vue-router";
import { useStore } from "vuex";

import { ACCOUNT_TYPE } from "@/constants";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const useRedirectBasedOnRole = () => {
  const store = useStore();
  const router = useRouter();

  return () => {
    const type = store.state.authentication.selectedAccount?.type_name;
    const orgUuid = store.state.authentication.selectedAccount?.uuid;

    if (type === ACCOUNT_TYPE.SYSTEM) {
      return router.push(buildOrgUrl("system", orgUuid));
    }

    if (type === ACCOUNT_TYPE.MSP) {
      return router.push(buildOrgUrl("msp", orgUuid));
    }

    if (type === ACCOUNT_TYPE.CUSTOMER) {
      return router.push(buildOrgUrl("customer", orgUuid));
    }

    return router.push("/auth");
  };
};
